<template>
  <div class="it-hero-slider" :class="textColorClass">
    <slot
      :sliderData="sliderData"
      :heroSliderSwiper="heroSliderSwiper"
      :totalSlides="totalSlides"
      :currentSlide="currentSlide"
      :hasNavigation="hasNavigation"
      :ready="ready"
    ></slot>
  </div>
</template>

<script lang="js">
import { Swiper, Navigation } from 'swiper/dist/js/swiper.esm';
Swiper.use([Navigation]);

export default {
  name: 'lms-hero-slider',
  props: {
    sliderData: {
      type: Array,
    },
  },
  data() {
    return {
      heroSliderSwiper: null,
      totalSlides: this.sliderData && this.sliderData.length,
      currentSlide: 1,
      hasNavigation: this.sliderData && this.sliderData.length > 1,
      ready: false,
      textColorClass: ''
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      const swiperOptions = {
        init: false,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: false,
        observeParents: false,
        direction: 'horizontal',
        navigation: {
          nextEl: '.hero-slider__button-next',
          prevEl: '.hero-slider__button-prev',
        },
        pagination: false,
        a11y: true,
      };

      const swiperContainer = this.$el.querySelector('.swiper-container');
      this.heroSliderSwiper = new Swiper(swiperContainer, swiperOptions);

      this.heroSliderSwiper.on('slideChange', this.handleSlideChange);

      this.heroSliderSwiper.on('slideChangeTransitionStart', () => {
        let $wrapperEl = this.heroSliderSwiper.$wrapperEl;
        let params = this.heroSliderSwiper.params;
        $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
            .each(function() {
              let idx = this.getAttribute('data-swiper-slide-index');
              this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
            });
      });

      this.heroSliderSwiper.on('slideChangeTransitionEnd', () => {
        this.currentSlide = this.heroSliderSwiper.realIndex + 1;
      });

      this.heroSliderSwiper.init();
      this.setSlideHeight();
      this.ready = true;
      this.updateComponentClasses();
    },
    setSlideHeight() {
      let maxHeight = 0;

      Array.from(this.heroSliderSwiper.slides).forEach(slide => {
        const slideHeight = slide.offsetHeight;

        if(slideHeight > maxHeight) {
          maxHeight = slideHeight;
        }
      });

      Array.from(this.heroSliderSwiper.slides).forEach(slide => {
        slide.querySelector('.wrapper.wrapper--secondary').style.height = maxHeight + 'px';
      });
    },
    updateComponentClasses() {
      const currentSlideIndex = this.heroSliderSwiper.realIndex;
      const currentSlide = this.sliderData[currentSlideIndex];
      const textColor = currentSlide["text_color"].value

      this.textColorClass = `it-hero-slider__text-${textColor}`;
    },
    handleSlideChange() {
      this.updateComponentClasses();
      this.setSlideHeight();
    },
  },
};
</script>
